export const invoiceTranslations = { 
  invoice: {
    type: {
      EXPENSES: "Expenses",
      EARNINGS: "Earnings"
    }
  }
}